"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var VisuallyHidden_1 = __importDefault(require("../VisuallyHidden"));

var TableLogicBase_1 = require("./TableLogicBase");

exports.VisuallyHiddenTable = function (props) {
  var tableProps = props.tableProps,
      globalConfiguration = props.globalConfiguration,
      translationContext = props.translationContext;
  var tableLogicBase = new TableLogicBase_1.TableLogicBase(tableProps, globalConfiguration);
  var columns = tableProps.columns,
      rows = tableProps.rows,
      placeholder = tableProps.placeholder;
  return react_1.default.createElement(VisuallyHidden_1.default, null, react_1.default.createElement("table", null, react_1.default.createElement("thead", null, react_1.default.createElement("tr", null, (columns || []).map(function (column) {
    return react_1.default.createElement("th", {
      key: column.key
    }, column.header);
  }))), react_1.default.createElement("tbody", null, (rows || []).map(function (row, index) {
    return react_1.default.createElement("tr", {
      key: "row_" + index
    }, (columns || []).map(function (column) {
      var value = tableLogicBase.formatValueForColumn(row[column.key], column, translationContext);

      if (ksys_app_template_1.utils.typeChecks.isNullOrUndefined(value)) {
        value = column.placeholder || placeholder;
      }

      return react_1.default.createElement("td", {
        key: column.key
      }, value);
    }));
  }))));
};